export function formatPhonePDF(value: string) {
  return `+${value}`;
}

export function formatInternationPhoneNumber(phoneNumber: string, phoneFormat?: string) {
  if (phoneFormat) {
    const format = phoneFormat.split('');
    const digits = phoneNumber.replace(/\D/g, '');

    let digitIndex = 0;
    let formattedPhone = '';

    for (const char of format) {
      if (char === '.') {
        formattedPhone += digits[digitIndex] || '';
        digitIndex++;
      } else {
        formattedPhone += char;
      }
    }

    return formattedPhone.replaceAll(/[.\-\s]/g, '');
  }
  return formatPhonePDF(phoneNumber);
}
